var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _PubNubChatClient_instances, _PubNubChatClient_pubSub, _PubNubChatClient_pubnub, _PubNubChatClient_roomKey, _PubNubChatClient_operationsQueue, _PubNubChatClient_tokenHandler, _PubNubChatClient_quotaHandler, _PubNubChatClient_state, _PubNubChatClient_notificationState, _PubNubChatClient_closed, _PubNubChatClient_onOperationsQueueErrors, _PubNubChatClient_onStateChange, _PubNubChatClient_onMessageAction, _PubNubChatClient_onMessage, _PubNubChatClient_deleteMessageFromPubNub, _PubNubChatClient_softDeleteChatMessage, _PubNubChatClient_handleErrors, _PubNubChatClient_handleError, _PubNubChatClient_pubNubPublish;
import globalLogger from "@lazarentertainment/js-logger";
import PubNub from "pubnub";
import { ChatState, DEFAULT_LIVE_MAX_CHAT_MESSAGES, DEFAULT_REPLAY_MAX_CHAT_MESSAGES, DEFAULT_STATE_CHANGE_THROTTLE_MS, } from "./chatState";
import { createChatError } from "./error";
import { QuotaHandler } from "./quotaHandler";
import { TokenHandler, } from "./tokenHandler";
import { STAGE_TEN_SOURCE_NAME, convertToPubNubTimetoken, getPubNubTimestamp, isValidReactionKey, parseChatMessageFetchResponse, createTextMessage, } from "./types";
import { KeyedOperationsQueue, } from "./util/keyedOperationsQueue";
import { wait } from "./util/promiseUtils";
const enqueueMessageKey = Symbol("enqueueMessage");
export const DEFAULT_CHAT_MODE = "live";
export const DEFAULT_FETCH_LIMIT = 100;
export class PubNubChatClient {
    constructor({ s10ChannelId, userId, roomKey, pubnubAccessToken, publishKey, subscribeKey, tokenRefreshTimeoutMs = 15000, onStateChangeThrottleMs = DEFAULT_STATE_CHANGE_THROTTLE_MS, mode = DEFAULT_CHAT_MODE, 
    // Be aware that having a low maxChatMessages can cause problems when replaying chat.
    // If the number of messages pre-loaded for replay exceeds maxChatMessages, then the
    // user won't see any messages at all.
    maxChatMessages = mode === "replay"
        ? DEFAULT_REPLAY_MAX_CHAT_MESSAGES
        : DEFAULT_LIVE_MAX_CHAT_MESSAGES, pubSub, notificationState, onTokenExpired, }) {
        _PubNubChatClient_instances.add(this);
        _PubNubChatClient_pubSub.set(this, void 0);
        _PubNubChatClient_pubnub.set(this, void 0);
        _PubNubChatClient_roomKey.set(this, void 0);
        _PubNubChatClient_operationsQueue.set(this, new KeyedOperationsQueue());
        _PubNubChatClient_tokenHandler.set(this, void 0);
        _PubNubChatClient_quotaHandler.set(this, void 0);
        _PubNubChatClient_state.set(this, void 0);
        _PubNubChatClient_notificationState.set(this, void 0);
        _PubNubChatClient_closed.set(this, false);
        _PubNubChatClient_onOperationsQueueErrors.set(this, (errorsByKey) => __awaiter(this, void 0, void 0, function* () {
            const errors = [...errorsByKey.values()];
            const handled = yield __classPrivateFieldGet(this, _PubNubChatClient_handleErrors, "f").call(this, errors);
            if (handled) {
                yield __classPrivateFieldGet(this, _PubNubChatClient_operationsQueue, "f").resume();
            }
            else {
                globalLogger.error(errors);
            }
        }));
        _PubNubChatClient_onStateChange.set(this, (state, prevState) => {
            if (__classPrivateFieldGet(this, _PubNubChatClient_closed, "f")) {
                return;
            }
            __classPrivateFieldGet(this, _PubNubChatClient_pubSub, "f").publish("stateChange", state);
            if (state.messages !== prevState.messages) {
                __classPrivateFieldGet(this, _PubNubChatClient_pubSub, "f").publish("messages", state.messages);
            }
            if (state.reactions !== prevState.reactions) {
                __classPrivateFieldGet(this, _PubNubChatClient_pubSub, "f").publish("reactions", state.reactions);
            }
        });
        _PubNubChatClient_onMessageAction.set(this, ({ data: { type, value, messageTimetoken, actionTimetoken, uuid }, event, }) => {
            if (type === "deleted") {
                const deletedMessage = __classPrivateFieldGet(this, _PubNubChatClient_state, "f").removeMessage(BigInt(messageTimetoken));
                if (deletedMessage) {
                    __classPrivateFieldGet(this, _PubNubChatClient_pubSub, "f").publish("messageDeleted", deletedMessage);
                }
            }
            if (type === "reaction" && isValidReactionKey(value)) {
                const reaction = {
                    isMe: uuid === __classPrivateFieldGet(this, _PubNubChatClient_pubnub, "f").getUserId(),
                    messageTimetoken: BigInt(messageTimetoken),
                    reactionKey: value,
                    reactionTimetoken: BigInt(actionTimetoken),
                    isOptimistic: false,
                };
                const reactionEvent = Object.assign({ event, userId: uuid }, reaction);
                if (event === "added") {
                    const reactionChange = __classPrivateFieldGet(this, _PubNubChatClient_state, "f").addReaction(reaction);
                    if (reactionChange) {
                        __classPrivateFieldGet(this, _PubNubChatClient_pubSub, "f").publish("reactionAdded", reactionEvent);
                    }
                }
                if (event === "removed") {
                    const reactionChange = __classPrivateFieldGet(this, _PubNubChatClient_state, "f").removeReaction(reaction);
                    if (reactionChange) {
                        __classPrivateFieldGet(this, _PubNubChatClient_pubSub, "f").publish("reactionRemoved", reactionEvent);
                    }
                }
            }
        });
        _PubNubChatClient_onMessage.set(this, (messageEvent) => {
            const message = createTextMessage(messageEvent, this.userId);
            if ((message === null || message === void 0 ? void 0 : message.type) === "chat") {
                __classPrivateFieldGet(this, _PubNubChatClient_state, "f").addMessage(message.data);
            }
            else if ((message === null || message === void 0 ? void 0 : message.type) === "notification") {
                __classPrivateFieldGet(this, _PubNubChatClient_notificationState, "f").addMessageBatch([message.data]);
            }
        });
        _PubNubChatClient_deleteMessageFromPubNub.set(this, (timetoken) => {
            return __classPrivateFieldGet(this, _PubNubChatClient_pubnub, "f").deleteMessages({
                channel: __classPrivateFieldGet(this, _PubNubChatClient_roomKey, "f"),
                /**
                 * The start and end timetoken parameter values are 1/10 nanosecond
                 * (last digit of timetoken) apart to delete the message stored at the
                 * end parameter's timetoken value.
                 *
                 * https://www.pubnub.com/docs/general/messages/actions#delete-messages
                 */
                end: timetoken.toString(),
                start: (timetoken - BigInt(1)).toString(),
            });
        });
        _PubNubChatClient_handleErrors.set(this, (errors) => __awaiter(this, void 0, void 0, function* () {
            const truthyErrors = errors.filter(({ error }) => !!error);
            let handled = false;
            // It's likely these errors have the same underlying cause.
            // Just handle one error and return. If this assumption is
            // wrong, we'll end up back here anyway.
            let index = 0;
            while (!handled && truthyErrors[index]) {
                // eslint-disable-next-line no-await-in-loop
                handled = yield __classPrivateFieldGet(this, _PubNubChatClient_handleError, "f").call(this, truthyErrors[index]);
                globalLogger.V1("Chat client error handled=", handled);
                index++;
            }
            return handled;
        }));
        _PubNubChatClient_handleError.set(this, ({ error, abort }) => __awaiter(this, void 0, void 0, function* () {
            const chatError = createChatError(error);
            globalLogger.log("Handling error", error, "as chat error", chatError);
            // TODO: Handle HTTP 5xx
            switch (chatError.code) {
                case "AuthenticationError": {
                    try {
                        __classPrivateFieldGet(this, _PubNubChatClient_tokenHandler, "f").triggerTokenExpired();
                        globalLogger.V1("Awaiting token refresh");
                        yield __classPrivateFieldGet(this, _PubNubChatClient_tokenHandler, "f").tokenRefreshPromise;
                        return true;
                    }
                    catch (localError) {
                        globalLogger.error(localError);
                        return false;
                    }
                }
                case "QuotaLimitReachedError": {
                    // QuotaHandler is listening for this error and handles it
                    __classPrivateFieldGet(this, _PubNubChatClient_pubSub, "f").publish("error", chatError);
                    return true;
                }
                case "DisplayNameRejectedError": {
                    __classPrivateFieldGet(this, _PubNubChatClient_pubSub, "f").publish("error", chatError);
                    return false;
                }
                default: {
                    abort(/* propagate */ false);
                    __classPrivateFieldGet(this, _PubNubChatClient_pubSub, "f").publish("error", chatError);
                    globalLogger.error("Unhandled PubNub error, aborting operation...", error);
                    return true;
                }
            }
        }));
        __classPrivateFieldSet(this, _PubNubChatClient_pubSub, pubSub, "f");
        __classPrivateFieldSet(this, _PubNubChatClient_pubnub, new PubNub({
            userId,
            publishKey,
            subscribeKey,
            restore: true,
        }), "f");
        __classPrivateFieldSet(this, _PubNubChatClient_roomKey, roomKey, "f");
        __classPrivateFieldSet(this, _PubNubChatClient_tokenHandler, new TokenHandler(__classPrivateFieldGet(this, _PubNubChatClient_pubnub, "f"), __classPrivateFieldGet(this, _PubNubChatClient_pubSub, "f"), {
            tokenRefreshTimeoutMs,
            s10ChannelId,
            onTokenExpired,
        }), "f");
        // Detail: it is important to set the token before subscribing, or else
        // PubNub will make a call to its /subscribe endpoint, which will fail
        // without authorization.
        if (pubnubAccessToken) {
            __classPrivateFieldGet(this, _PubNubChatClient_tokenHandler, "f").setToken(pubnubAccessToken);
        }
        if (mode === "live") {
            __classPrivateFieldGet(this, _PubNubChatClient_pubnub, "f").subscribe({ channels: [roomKey] });
            __classPrivateFieldGet(this, _PubNubChatClient_pubnub, "f").addListener({
                status: (status) => {
                    if ("statusCode" in status && status.statusCode === 403) {
                        __classPrivateFieldGet(this, _PubNubChatClient_tokenHandler, "f").triggerTokenExpired();
                    }
                },
                messageAction: __classPrivateFieldGet(this, _PubNubChatClient_onMessageAction, "f"),
                message: __classPrivateFieldGet(this, _PubNubChatClient_onMessage, "f"),
            });
        }
        __classPrivateFieldSet(this, _PubNubChatClient_state, new ChatState(__classPrivateFieldGet(this, _PubNubChatClient_onStateChange, "f"), {
            maxChatMessages,
            onStateChangeThrottleMs,
            onDuplicateMessage: (timetoken) => {
                // Duplicate messages can occur if the client sends the same message twice, perhaps
                // because it retried due to a timeout, but the original operation actually succeeded.
                // It makes sense to delete the duplicates, because their content is guaranteed to
                // be identical to the original. A soft delete is not necessary, because ChatState
                // will deduplicate the local state.
                if (this.isChannelOwner) {
                    __classPrivateFieldGet(this, _PubNubChatClient_operationsQueue, "f").enqueue(timetoken.toString(), () => __classPrivateFieldGet(this, _PubNubChatClient_deleteMessageFromPubNub, "f").call(this, timetoken));
                }
            },
        }), "f");
        __classPrivateFieldSet(this, _PubNubChatClient_notificationState, notificationState, "f");
        __classPrivateFieldSet(this, _PubNubChatClient_quotaHandler, new QuotaHandler(__classPrivateFieldGet(this, _PubNubChatClient_pubSub, "f")), "f");
        __classPrivateFieldGet(this, _PubNubChatClient_operationsQueue, "f").subscribe("errors", __classPrivateFieldGet(this, _PubNubChatClient_onOperationsQueueErrors, "f"));
    }
    updateAuth(userId, token) {
        // Detail: It is important to set the userId first, since we reconnect
        // to PubNub if our token has changed. The userId set on PubNub must
        // match the userId associated with the token, otherwise you will get
        // a 403 on reconnect.
        __classPrivateFieldGet(this, _PubNubChatClient_pubnub, "f").setUserId(userId);
        __classPrivateFieldGet(this, _PubNubChatClient_tokenHandler, "f").setToken(token);
    }
    get userId() {
        return __classPrivateFieldGet(this, _PubNubChatClient_pubnub, "f").getUUID();
    }
    get roomKey() {
        return __classPrivateFieldGet(this, _PubNubChatClient_roomKey, "f");
    }
    get messages() {
        return this.state.messages;
    }
    get reactions() {
        return this.state.reactions;
    }
    get state() {
        return __classPrivateFieldGet(this, _PubNubChatClient_state, "f").state;
    }
    get isChannelOwner() {
        return __classPrivateFieldGet(this, _PubNubChatClient_tokenHandler, "f").isChannelOwner;
    }
    get quotaRefreshSecondsRemaining() {
        return __classPrivateFieldGet(this, _PubNubChatClient_quotaHandler, "f").quotaRefreshSecondsRemaining;
    }
    clearState() {
        __classPrivateFieldGet(this, _PubNubChatClient_state, "f").clear();
    }
    /**
     * Fetches messages from the network and returns them, regardless
     * of whether they are already in state. Does not modify chat state.
     */
    fetchMessages(_a) {
        var _b, _c, _d;
        var { limit = DEFAULT_FETCH_LIMIT, loadActionsStrategy = "include", onBatch, abortSignal } = _a, args = __rest(_a, ["limit", "loadActionsStrategy", "onBatch", "abortSignal"]);
        return __awaiter(this, void 0, void 0, function* () {
            console.assert(limit > 0, "Expected limit > 0");
            const { end: fetchEndTime, start: initialStartTime } = normalizeFetchTimestamps(args);
            // If there's no specified start time, use Date.now(). This allows us to track
            // if there are messages in the given range.
            let fetchStartTime = initialStartTime !== null && initialStartTime !== void 0 ? initialStartTime : getPubNubTimestamp(Date.now());
            /**
             * Max that can be fetched when including messages reactions is 25
             *
             * https://www.pubnub.com/docs/chat/sdks/messages/message-history#fetch-messages-with-reactions
             */
            const fetchLimit = loadActionsStrategy === "include" ? 25 : 100;
            const messages = [];
            let done = false;
            do {
                const fetchCount = Math.min(fetchLimit, limit - messages.length);
                console.assert(fetchCount > 0, "Expected fetchCount > 0");
                // eslint-disable-next-line @typescript-eslint/no-loop-func
                const [fetchPromise] = __classPrivateFieldGet(this, _PubNubChatClient_operationsQueue, "f").enqueue(() => __classPrivateFieldGet(this, _PubNubChatClient_pubnub, "f").fetchMessages({
                    channels: [__classPrivateFieldGet(this, _PubNubChatClient_roomKey, "f")],
                    includeCustomMessageType: true,
                    /**
                     * If you specify only the start parameter (without end), you will receive
                     * messages older than the start timetoken value.
                     *
                     * Specify values for both start and end to retrieve messages between those
                     * timetokens (inclusive of the end value).
                     *
                     * https://www.pubnub.com/docs/chat/sdks/messages/message-history#start-and-end-parameters
                     */
                    start: fetchStartTime.toString(),
                    /**
                     * If you specify only the end parameter (without start), you will receive
                     * messages from the last (most recent) message going back to that timetoken value.
                     *
                     * Specify values for both start and end to retrieve messages between those
                     * timetokens (inclusive of the end value).
                     *
                     * https://www.pubnub.com/docs/chat/sdks/messages/message-history#start-and-end-parameters
                     */
                    end: fetchEndTime === null || fetchEndTime === void 0 ? void 0 : fetchEndTime.toString(),
                    count: fetchCount,
                    // TODO: Fetch reactions separately if loadActionsStrategy === "fetch"
                    includeMessageActions: loadActionsStrategy === "include",
                }));
                // eslint-disable-next-line no-await-in-loop
                const result = yield fetchPromise;
                // TODO: Using an AbortSignal is a better pattern than the operation queue's
                // built-in abort callback. We should migrate to use that everywhere.
                // In the meantime, this operation may have been aborted by either method.
                // Note carefully the circumstances in which we might break here:
                //   - There was an error and the error handler aborted the operation
                //   - The caller of fetchMessages passed an AbortSignal, and aborted
                //   - The client was closed (note: this also aborts the operation)
                if (result.type === "aborted" || (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) || __classPrivateFieldGet(this, _PubNubChatClient_closed, "f")) {
                    console.log("Aborting PubNub fetch");
                    break;
                }
                const rawMessages = (_b = result.value.channels[__classPrivateFieldGet(this, _PubNubChatClient_roomKey, "f")]) !== null && _b !== void 0 ? _b : [];
                const parsedBatch = parseChatMessageFetchResponse(rawMessages, this.userId);
                messages.unshift(...parsedBatch);
                const earliestMessage = messages[0];
                done =
                    // If we fetched for `n` and got less than `n` then there are no more messages
                    // left to be fetched from PubNub
                    rawMessages.length < fetchCount ||
                        // This means there are no messages at all in the fetched range
                        !earliestMessage ||
                        // If the earliest message that we have is older or the same age as our
                        // fetchEndTime then we've got all the messages requested
                        (typeof fetchEndTime === "bigint" &&
                            ((_c = earliestMessage.data) === null || _c === void 0 ? void 0 : _c.timetoken) <= fetchEndTime);
                onBatch === null || onBatch === void 0 ? void 0 : onBatch(parsedBatch, {
                    start: fetchStartTime,
                    end: done ? fetchEndTime : undefined,
                });
                fetchStartTime = (_d = earliestMessage === null || earliestMessage === void 0 ? void 0 : earliestMessage.data) === null || _d === void 0 ? void 0 : _d.timetoken;
            } while (!done && messages.length < limit);
            return messages;
        });
    }
    /**
     * Loads messages into state
     */
    loadMessages(_a) {
        var { limit = DEFAULT_FETCH_LIMIT, loadActionsStrategy = "include", onBatch } = _a, args = __rest(_a, ["limit", "loadActionsStrategy", "onBatch"]);
        return __awaiter(this, void 0, void 0, function* () {
            const { end, start } = __classPrivateFieldGet(this, _PubNubChatClient_state, "f").truncateFetchRange(
            // TODO: This is minor but, notice that we have to call
            // `normalizeFetchTimestamps` here, and then again in
            // `fetchMessages` if we actually go to the network.
            // Would be nice to only call it once.
            normalizeFetchTimestamps(args));
            if (typeof end === "bigint" && end === start) {
                // These messages are already in state
                return;
            }
            yield this.fetchMessages(Object.assign(Object.assign({ limit,
                loadActionsStrategy }, args), { onBatch: (messages, range) => {
                    const chatMessages = [];
                    const notifications = [];
                    messages.forEach(({ type, data }) => {
                        if (type === "chat") {
                            chatMessages.push(data);
                        }
                        else if (type === "notification") {
                            notifications.push(data);
                        }
                    });
                    __classPrivateFieldGet(this, _PubNubChatClient_state, "f").addMessageBatchWithReactions(chatMessages, range);
                    __classPrivateFieldGet(this, _PubNubChatClient_notificationState, "f").addMessageBatch(notifications);
                    onBatch === null || onBatch === void 0 ? void 0 : onBatch(messages, range);
                } }));
        });
    }
    deleteMessage(messageKeyOrTimetoken) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _PubNubChatClient_state, "f").removeMessage(messageKeyOrTimetoken, true);
            if (typeof messageKeyOrTimetoken === "string") {
                return;
            }
            const timetoken = messageKeyOrTimetoken;
            const [deletePromise] = __classPrivateFieldGet(this, _PubNubChatClient_operationsQueue, "f").enqueueAll(timetoken.toString(), 
            // Calling `deleteMessages` deletes the message from the PubNub servers
            // When new clients come online and fetch message history, the history will
            // not include this message.
            () => __classPrivateFieldGet(this, _PubNubChatClient_deleteMessageFromPubNub, "f").call(this, timetoken), 
            // We also do a soft delete (represented as a message action) to notify
            // clients that are already online and have this message that they should
            // go ahead and remove the message
            () => __classPrivateFieldGet(this, _PubNubChatClient_instances, "m", _PubNubChatClient_softDeleteChatMessage).call(this, timetoken));
            try {
                yield deletePromise;
            }
            catch (_a) {
                throw { code: "DeleteMessageError" };
            }
        });
    }
    /**
     * Accepts `getDisplayName`, in case the user's display name is rejected,
     * we can get the most recent updated name.
     */
    enqueueMessage(message, userIsBanned, getDisplayName) {
        const { quotaRefreshMsRemaining } = __classPrivateFieldGet(this, _PubNubChatClient_quotaHandler, "f");
        if (quotaRefreshMsRemaining) {
            const error = {
                code: "QuotaLimitReachedError",
                refreshTimeMs: quotaRefreshMsRemaining,
            };
            __classPrivateFieldGet(this, _PubNubChatClient_pubSub, "f").publish("error", error);
            throw error;
        }
        const { messageKey } = __classPrivateFieldGet(this, _PubNubChatClient_state, "f").addMessage({
            userId: this.userId,
            displayName: getDisplayName(),
            isChannelOwner: this.isChannelOwner,
            text: message.message,
            sourceName: STAGE_TEN_SOURCE_NAME,
        });
        // TODO: The desired behaviour when the user is banned should be left up
        // to the application. Unfortunately at the moment the app's chat state
        // depends on us adding this message to optimistic state, and then not
        // sending it if the user is banned. So, this is slightly awkward. It
        // would be fixed if the application owned the reference to ChatState
        // and passed it to us.
        if (userIsBanned) {
            return {
                messageKey,
                promise: Promise.resolve({
                    type: "aborted",
                    value: undefined,
                }),
            };
        }
        const [promise] = __classPrivateFieldGet(this, _PubNubChatClient_operationsQueue, "f").enqueue(enqueueMessageKey, () => __awaiter(this, void 0, void 0, function* () {
            const refreshTimeMs = __classPrivateFieldGet(this, _PubNubChatClient_quotaHandler, "f").quotaRefreshMsRemaining;
            if (refreshTimeMs) {
                yield wait(refreshTimeMs);
            }
            // Don't enforce client-side quota handling for channel owners. We don't expect
            // owners to have quotas, but if they do, that can be enforced at the backend.
            if (!this.isChannelOwner) {
                __classPrivateFieldGet(this, _PubNubChatClient_quotaHandler, "f").mark(messageKey);
            }
            return __classPrivateFieldGet(this, _PubNubChatClient_instances, "m", _PubNubChatClient_pubNubPublish).call(this, Object.assign(Object.assign({}, message), { displayName: getDisplayName(), messageKey }));
        }));
        return {
            promise,
            messageKey,
        };
    }
    getLoadedRangeIntersecting(timetoken) {
        return __classPrivateFieldGet(this, _PubNubChatClient_state, "f").getLoadedRangeIntersecting(timetoken);
    }
    addReaction(reactionKey, messageTimetoken) {
        __classPrivateFieldGet(this, _PubNubChatClient_state, "f").addReaction({
            messageTimetoken,
            reactionKey,
            isOptimistic: true,
        });
        __classPrivateFieldGet(this, _PubNubChatClient_operationsQueue, "f").enqueue(() => __classPrivateFieldGet(this, _PubNubChatClient_pubnub, "f")
            .addMessageAction({
            messageTimetoken: messageTimetoken.toString(),
            action: {
                type: "reaction",
                value: reactionKey,
            },
            channel: __classPrivateFieldGet(this, _PubNubChatClient_roomKey, "f"),
        })
            // TODO: error handling
            .catch(globalLogger.error));
    }
    removeReaction(reactionKey, messageTimetoken, reactionTimetoken) {
        __classPrivateFieldGet(this, _PubNubChatClient_state, "f").removeReaction({
            messageTimetoken,
            reactionKey,
            isOptimistic: true,
        });
        __classPrivateFieldGet(this, _PubNubChatClient_operationsQueue, "f").enqueue(() => __classPrivateFieldGet(this, _PubNubChatClient_pubnub, "f")
            .removeMessageAction({
            messageTimetoken: messageTimetoken.toString(),
            actionTimetoken: reactionTimetoken.toString(),
            channel: __classPrivateFieldGet(this, _PubNubChatClient_roomKey, "f"),
        })
            // TODO: Error handling
            // Here, for example, we may get HTTP 409 Conflict,
            // because a reaction was already removed.
            .catch(globalLogger.error));
    }
    getReactionTimetoken(reactionKey, messageTimetoken) {
        return __classPrivateFieldGet(this, _PubNubChatClient_state, "f").getReactionTimetoken(messageTimetoken, reactionKey);
    }
    close() {
        __classPrivateFieldSet(this, _PubNubChatClient_closed, true, "f");
        __classPrivateFieldGet(this, _PubNubChatClient_tokenHandler, "f").reset();
        __classPrivateFieldGet(this, _PubNubChatClient_quotaHandler, "f").close();
        __classPrivateFieldGet(this, _PubNubChatClient_operationsQueue, "f").abortAll();
        __classPrivateFieldGet(this, _PubNubChatClient_pubnub, "f").unsubscribeAll();
        __classPrivateFieldGet(this, _PubNubChatClient_pubnub, "f").stop();
    }
}
_PubNubChatClient_pubSub = new WeakMap(), _PubNubChatClient_pubnub = new WeakMap(), _PubNubChatClient_roomKey = new WeakMap(), _PubNubChatClient_operationsQueue = new WeakMap(), _PubNubChatClient_tokenHandler = new WeakMap(), _PubNubChatClient_quotaHandler = new WeakMap(), _PubNubChatClient_state = new WeakMap(), _PubNubChatClient_notificationState = new WeakMap(), _PubNubChatClient_closed = new WeakMap(), _PubNubChatClient_onOperationsQueueErrors = new WeakMap(), _PubNubChatClient_onStateChange = new WeakMap(), _PubNubChatClient_onMessageAction = new WeakMap(), _PubNubChatClient_onMessage = new WeakMap(), _PubNubChatClient_deleteMessageFromPubNub = new WeakMap(), _PubNubChatClient_handleErrors = new WeakMap(), _PubNubChatClient_handleError = new WeakMap(), _PubNubChatClient_instances = new WeakSet(), _PubNubChatClient_softDeleteChatMessage = function _PubNubChatClient_softDeleteChatMessage(messageTimetoken) {
    return __awaiter(this, void 0, void 0, function* () {
        yield __classPrivateFieldGet(this, _PubNubChatClient_pubnub, "f").addMessageAction({
            messageTimetoken: messageTimetoken.toString(),
            action: {
                type: "deleted",
                value: ".",
            },
            channel: __classPrivateFieldGet(this, _PubNubChatClient_roomKey, "f"),
        });
    });
}, _PubNubChatClient_pubNubPublish = function _PubNubChatClient_pubNubPublish({ message, displayName, environment, messageKey, sourceName, }) {
    return __awaiter(this, void 0, void 0, function* () {
        // PubNub.PublishResponse claims that timetoken is a number here,
        // but in fact at runtime it is a string.
        const { timetoken } = yield __classPrivateFieldGet(this, _PubNubChatClient_pubnub, "f").publish({
            message: {
                displayName,
                text: message,
                environment,
                messageKey,
                sourceName,
            },
            channel: __classPrivateFieldGet(this, _PubNubChatClient_roomKey, "f"),
            sendByPost: true,
            customMessageType: "chat",
        });
        const timetokenBigInt = BigInt(timetoken);
        const optimisticMessage = this.messages.get(messageKey);
        if (optimisticMessage) {
            // Adding this update here means the caller can await this method's promise,
            // and use the resolved timetoken to query local state for the message.
            __classPrivateFieldGet(this, _PubNubChatClient_state, "f").addMessage(Object.assign(Object.assign({}, optimisticMessage), { 
                // Note that we preserve the optimistic timestampMs. Otherwise, messages
                // will be reordered as their timestamps are updated, which has the effect
                // of messages jumping around in the UI.
                timetoken: timetokenBigInt }));
        }
        return timetokenBigInt;
    });
};
function normalizeFetchTimestamps(args) {
    switch (args.type) {
        case "latest": {
            return {
                end: getPubNubTimestamp(Math.max(Date.now() - args.seconds * 1000, 0)),
                start: undefined,
            };
        }
        case "range": {
            console.assert(args.end >= 0, "Expected end >= 0");
            console.assert(args.end < args.start, "Expected end < start");
            const start = convertToPubNubTimetoken(args.start);
            return {
                end: convertToPubNubTimetoken(args.end),
                start: args.inclusiveOfStart ? start + BigInt(1) : start,
            };
        }
        case "count": {
            console.assert(args.start > 0, "Expected start > 0");
            const start = convertToPubNubTimetoken(args.start);
            return {
                end: undefined,
                start: args.inclusiveOfStart ? start + BigInt(1) : start,
            };
        }
        default: {
            throw new Error(`Unexpected fetch type: ${args}`);
        }
    }
}
